import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import SignsItSupport2 from '../../../components/Satellites/itSupport/SignsItSupport/SignsItSupport2/SignsItSupport2';
import SignsItSupport3 from '../../../components/Satellites/itSupport/SignsItSupport/SignsItSupport3/SignsItSupport3';
import SignsItSupport4 from '../../../components/Satellites/itSupport/SignsItSupport/SignsItSupport4/SignsItSupport4';

class SignsItSupport extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="signs_it_support" />
        <ServiceBanner {...this.props} page="signsItSupport" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <SignsItSupport2 {...this.props} />
        <SignsItSupport3 {...this.props} />
        <SignsItSupport4 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(SignsItSupport);
